import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        display: 'flex',
        flexDirection: 'column',
        // The CUI strip is the footer's full-width lower surface; the main
        // footer row keeps its own muted background above it.
        backgroundColor: (theme) => theme.palette.action.hover,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        data-testid="footer-content-row"
        sx={{
          py: 2,
          px: 2,
          width: '100%',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          alignItems: 'center',
          columnGap: 2,
          rowGap: { xs: 1, sm: 0 },
          backgroundColor: (theme) => theme.palette.surfaceMuted,
        }}
      >
        <Box
          component="img"
          src="/rja-logo-text.svg"
          alt="RJA Technologies"
          sx={{
            height: 30,
            justifySelf: { xs: 'center', sm: 'start' },
            width: 'auto',
          }}
        />
      </Box>
      <Typography
        data-testid="cui-footer-notice"
        data-cui-surface="footer-full-width"
        data-cui-text-size="increased"
        variant="caption"
        color="success.main"
        align="center"
        sx={{
          width: '100%',
          px: { xs: 1, sm: 3 },
          pt: 0.75,
          pb: 0.5,
          fontWeight: 700,
          fontSize: { xs: '0.8125rem', sm: '0.875rem' },
        }}
      >
        UNCLASSIFIED — CUI NOT AUTHORIZED. Do not enter, paste, upload, or process CUI in Waypoint.
      </Typography>
    </Box>
  );
};

export default Footer;
